/**
 * Mega Menu Interactions
 * Handles full-width mega menu dropdowns with enhanced UX
 */

(function($) {
  'use strict';

  class MegaMenu {
    constructor() {
      this.megaMenuItems = $('.mega-menu-item');
      this.openDelay = 150;
      this.closeDelay = 300;

      this.init();
    }

    init() {
      if (this.megaMenuItems.length === 0) {
        return;
      }

      this.bindEvents();
      this.setupAccessibility();
    }

    bindEvents() {
      // Namespaced so re-initializing on resize (see bottom of file) replaces
      // the previous binding instead of stacking a duplicate set on top of it.
      const NS = '.megaMenu';
      this.megaMenuItems.off(NS);
      this.megaMenuItems.find('> .nav-link').off(NS);
      $(document).off(NS);

      // Desktop hover interactions
      if (window.matchMedia('(min-width: 992px)').matches) {
        this.megaMenuItems.each((index, item) => {
          const $item = $(item);
          const $link = $item.find('> .nav-link');

          // Mouse enter - show mega menu after a short delay, unless the
          // pointer leaves first (tracked via mouseleave below rather than
          // polling the :hover pseudo-class, which isn't reliable enough
          // here to gate opening the menu).
          $item.on('mouseenter' + NS, () => {
            clearTimeout($item.data('mmCloseTimeout'));
            clearTimeout($item.data('mmOpenTimeout'));

            const openTimeout = setTimeout(() => {
              this.closeAllMenus();
              this.openMenu($item);
            }, this.openDelay);
            $item.data('mmOpenTimeout', openTimeout);
          });

          // Mouse leave - cancel any pending open, hide mega menu with delay
          $item.on('mouseleave' + NS, () => {
            clearTimeout($item.data('mmOpenTimeout'));

            const closeTimeout = setTimeout(() => {
              this.closeMenu($item);
            }, this.closeDelay);
            $item.data('mmCloseTimeout', closeTimeout);
          });

          // Click on nav link
          $link.on('click' + NS, (e) => {
            // If mega menu is already open, allow navigation to main URL
            if ($item.hasClass('show')) {
              return true;
            }

            // Otherwise, open mega menu on first click
            e.preventDefault();
            this.closeAllMenus();
            this.openMenu($item);
          });
        });

        // Close all menus when clicking outside
        $(document).on('click' + NS, (e) => {
          if (!$(e.target).closest('.mega-menu-item').length) {
            this.closeAllMenus();
          }
        });

        // Close all menus on escape key
        $(document).on('keydown' + NS, (e) => {
          if (e.key === 'Escape') {
            this.closeAllMenus();
          }
        });
      }

      // Mobile touch interactions
      this.megaMenuItems.find('> .nav-link').on('touchstart' + NS, (e) => {
        if (window.matchMedia('(max-width: 991.98px)').matches) {
          const $item = $(e.currentTarget).parent();

          if (!$item.hasClass('show')) {
            e.preventDefault();
            this.closeAllMenus();
            this.openMenu($item);
          }
        }
      });
    }

    openMenu($item) {
      $item.addClass('show');
      $item.find('> .nav-link').attr('aria-expanded', 'true');
      $item.find('.mega-menu').attr('aria-hidden', 'false');
    }

    closeMenu($item) {
      $item.removeClass('show');
      $item.find('> .nav-link').attr('aria-expanded', 'false');
      $item.find('.mega-menu').attr('aria-hidden', 'true');
    }

    closeAllMenus() {
      this.megaMenuItems.each((index, item) => {
        this.closeMenu($(item));
      });
    }

    setupAccessibility() {
      // Set initial ARIA attributes
      this.megaMenuItems.each((index, item) => {
        const $item = $(item);
        const $link = $item.find('> .nav-link');
        const $megaMenu = $item.find('.mega-menu');
        const menuId = `mega-menu-${index}`;

        $megaMenu.attr({
          'id': menuId,
          'aria-hidden': 'true',
          'role': 'menu'
        });

        $link.attr({
          'aria-expanded': 'false',
          'aria-controls': menuId,
          'aria-haspopup': 'true'
        });
      });

      // Keyboard navigation within mega menu
      this.megaMenuItems.on('keydown', '.mega-menu a', (e) => {
        const $currentLink = $(e.currentTarget);
        const $allLinks = $currentLink.closest('.mega-menu').find('a');
        const currentIndex = $allLinks.index($currentLink);

        switch(e.key) {
          case 'ArrowDown':
            e.preventDefault();
            if (currentIndex < $allLinks.length - 1) {
              $allLinks.eq(currentIndex + 1).focus();
            }
            break;
          
          case 'ArrowUp':
            e.preventDefault();
            if (currentIndex > 0) {
              $allLinks.eq(currentIndex - 1).focus();
            }
            break;

          case 'Home':
            e.preventDefault();
            $allLinks.first().focus();
            break;

          case 'End':
            e.preventDefault();
            $allLinks.last().focus();
            break;

          case 'Tab':
            // Allow normal tab behavior, close menu when tabbing out
            if (!e.shiftKey && currentIndex === $allLinks.length - 1) {
              this.closeAllMenus();
            }
            break;
        }
      });
    }
  }

  // Initialize mega menu when DOM is ready
  $(document).ready(function() {
    new MegaMenu();
  });

  // Reinitialize on window resize to handle mobile/desktop transitions
  let resizeTimeout;
  $(window).on('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      new MegaMenu();
    }, 250);
  });

})(jQuery);
